module.exports = __webpack_public_path__ + "static/media/WelcomeBadge.d8bcb765.svg";